import { render } from "./Tabs.vue?vue&type=template&id=6f80b15e"
import script from "./Tabs.vue?vue&type=script&lang=js"
export * from "./Tabs.vue?vue&type=script&lang=js"

import exportComponent from "/Users/brianng/Desktop/supa/ionic/SupaFoundation/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])